import React from 'react';
import { TableCell, Typography } from '@mui/material';
import { TSortableColumn } from '../../Components/GenericTable/types';

interface CandidateGroup {
  id: number;
  name: string;
  position: string;
  location: string;
  emails: string[];
  phones: string[];
  contacts_revealed: boolean;
  candidate_pools: {
    id: number;
    title: string;
  }[];
}

interface CandidateGroupTableRowsProps {
  column: TSortableColumn;
  item: CandidateGroup;
  tableHovered: boolean;
  dispatch?: any;
}

const CandidateGroupTableRows: React.FC<CandidateGroupTableRowsProps> = ({
  column,
  item,
  tableHovered,
  dispatch
}) => {
  const formatEmails = (emails: string[]) => {
    if (!emails || emails.length === 0) return '-';
    return emails.join(', ');
  };

  const formatPhones = (phones: string[]) => {
    if (!phones || phones.length === 0) return '-';
    return phones.join(', ');
  };

  switch (column.id) {
    case 'name':
      return (
        <TableCell>
          <Typography variant="body2">{item.name || '-'}</Typography>
        </TableCell>
      );
    case 'position':
      return (
        <TableCell>
          <Typography variant="body2">{item.position || '-'}</Typography>
        </TableCell>
      );
    case 'location':
      return (
        <TableCell>
          <Typography variant="body2">{item.location || '-'}</Typography>
        </TableCell>
      );
    case 'emails':
      return (
        <TableCell>
          <Typography variant="body2">{formatEmails(item.emails)}</Typography>
        </TableCell>
      );
    case 'phones':
      return (
        <TableCell>
          <Typography variant="body2">{formatPhones(item.phones)}</Typography>
        </TableCell>
      );
    case 'pools':
      return (
        <TableCell>
          {item.candidate_pools.map((pool) => (
            <span key={pool.id}>{pool.title}</span>
          ))}
        </TableCell>
      );
    default:
      return <TableCell />;
  }
};

export default CandidateGroupTableRows;
